import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarCheck4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendarCheck4"><Path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H15V4H9V2H7V4ZM15.9142 10.75L11 15.6642L8.08579 12.75L9.5 11.3358L11 12.8358L14.5 9.33579L15.9142 10.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarCheck4;
